module.exports = __webpack_public_path__ + "img/round.9883902c.png";